import {
  signIn,
  signOut,
  signUp,
  confirmSignUp,
  getCurrentUser,
  fetchAuthSession,
} from 'aws-amplify/auth';

export async function login(email: string, password: string) {
  return signIn({ username: email, password });
}

export async function logout() {
  return signOut();
}

export async function register(email: string, password: string) {
  return signUp({
    username: email,
    password,
    options: { userAttributes: { email } },
  });
}

export async function confirmRegistration(email: string, code: string) {
  return confirmSignUp({ username: email, confirmationCode: code });
}

export async function getAuthToken(): Promise<string | null> {
  // import.meta.env.DEV is statically false in production builds, so Vite
  // tree-shakes this mock-token branch out of the prod bundle entirely.
  if (import.meta.env.DEV && import.meta.env.VITE_COGNITO_USER_POOL_ID?.startsWith('local')) {
    // Local dev mock token with valid sub claim
    const header = btoa(JSON.stringify({ alg: 'HS256', typ: 'JWT' }));
    const payload = btoa(
      JSON.stringify({
        sub: 'local-user-123',
        email: 'dev@local.test',
        exp: Math.floor(Date.now() / 1000) + 3600,
      })
    );
    return `${header}.${payload}.mock-signature`;
  }
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}

export async function getCurrentUserInfo() {
  return getCurrentUser();
}
